import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form, Input, Button, Icon } from "antd";
import { signin } from "./actions";
import { createLoadingSelector } from "../../store/api/selectors";

import "../../styles/css/pages/auth.css";

class Signin extends Component {
  state = {
    User: "",
    Secret: "",
  };

  componentDidMount() {
    document.title = "e-Recuperador - Login";
  }

  handleChange = (e) => {
    const value = e.target.value,
      name = e.target.name;

    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err) => {
      if (!err) {
        this.props.signin(this.state);
      }
    });
  };

  render() {
    const { isFetching } = this.props,
      { getFieldDecorator } = this.props.form;

    return (
      <div className="auth">
        <img
          className="auth__logo"
          src="https://images.e-auditoria.com.br/global/logos/png/erecuperador.png"
          alt="e-Recuperador"
        />

        <Form className="auth__form" onSubmit={this.handleSubmit}>
          <div className="auth__form___body">
            <Form.Item>
              {getFieldDecorator("User", {
                rules: [
                  { required: true, message: "O campo email é obrigatório" },
                ],
              })(
                <Input
                  name="User"
                  placeholder="Email"
                  size="large"
                  prefix={
                    <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  onChange={this.handleChange}
                />
              )}
            </Form.Item>

            <Form.Item>
              {getFieldDecorator("Secret", {
                rules: [
                  { required: true, message: "O campo senha é obrigatório" },
                ],
              })(
                <Input
                  name="Secret"
                  type="password"
                  placeholder="Senha"
                  size="large"
                  prefix={
                    <Icon type="key" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  onChange={this.handleChange}
                />
              )}
            </Form.Item>
          </div>

          <div className="auth__form___footer">
            <Button
              className="btn"
              size="large"
              type="primary"
              htmlType="submit"
              loading={isFetching ? true : false}
            >
              Entrar
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const loadingSelector = createLoadingSelector(["SIGNIN"]);
const mapStateToProps = (state) => ({
  isFetching: loadingSelector(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ signin }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create({ name: "signin" })(Signin));
